import React, { useEffect, useRef } from 'react';
import { store } from 'redux/store';
import {
  setCurrentTab,
} from 'redux/reducers/agroLayoutReducer';
import RoundTabButton from 'components/DesignSystem/Tabs/DiscreteTabs/RoundTabButton';
import { Card } from 'react-bootstrap';
import useControls from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useControls';
import useRedirectFromMap from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useRedirectFromMap';
import TFDVChart from 'components/Meteorology/Agro/TrackingForecast/DetailedView/Chart';
import DetailedViewMobile from 'components/Meteorology/Agro/TrackingForecast/DetailedView/Mobile';
import Button from 'components/DesignSystem/Button';
import './index.scss';
import useChartData from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useChartData';
import useHeatmapAwareDownload from 'hooks/Meteorology/TrackingForecast/useHeatmapAwareDownload';
import useIsMobile from 'utils/hooks/useIsMobile';
import { useSelector } from 'react-redux';
import { selectDVCPMATrackingForecastSubpage } from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { SUBPAGE_NAMES } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';

export default function DetailedView() {
  useEffect(() => {
    store.dispatch(setCurrentTab('agro/trackingforecast/detailedview'));
  }, []);
  useRedirectFromMap();
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const { subpageButtonProps, chartMode, setChartMode } = useControls();
  const dvImages = useRef<HTMLDivElement>(null);
  // #2009 item 8: heatmap na tela → PDF com a tabela inteira; gráfico de linhas → imagem.
  const { data: chartOption } = useChartData();
  const { download, label: downloadLabel } = useHeatmapAwareDownload(dvImages, chartOption);
  const isMobile = useIsMobile();
  const subpageName = SUBPAGE_NAMES[subpage] ?? SUBPAGE_NAMES.locations;
  const filename = `agro_acompanhamento_previsao_${subpageName.split(' ').join('_').toLowerCase()}`;

  // O early-return vem depois de todos os hooks: `setCurrentTab` e `useRedirectFromMap`
  // precisam rodar também no mobile (o primeiro é lido por useDeleteLocationGroup).
  if (isMobile) {
    return <DetailedViewMobile />;
  }

  return (
    <>
      <div className="d-flex justify-content-center round-discrete-tabs">
        {subpageButtonProps.map((buttonProps) => (
          <RoundTabButton
            key={buttonProps.text}
            onClick={buttonProps.onClick}
            text={buttonProps.text}
            active={buttonProps.active}
          />
        ))}
      </div>
      <Card className="content-card p-3 mx-5 mt-4 mb-5 h-100">
        <div className="d-flex justify-content-end">
          <Button
            className={`chart-mode-button${chartMode === 'line' ? ' active' : ''}`}
            type="tertiary"
            icon="line_axis"
            onClick={() => setChartMode('line')}
          />
          <Button
            className={`ms-1 chart-mode-button${chartMode === 'heatmap' ? ' active' : ''}`}
            type="tertiary"
            icon="table_rows"
            onClick={() => setChartMode('heatmap')}
          />
          <Button
            className="ms-3"
            type="tertiary"
            icon="download"
            onClick={download(filename)}
            aria-label={downloadLabel}
            title={downloadLabel}
          />
        </div>
        <div ref={dvImages}>
          <TFDVChart />
        </div>
      </Card>
    </>
  );
}
